import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Overline } from "../components/Overline";
import { SERVICES, MEDIA } from "../lib/site";
import { Seo } from "../components/Seo";

export default function Services() {
  return (
    <div data-testid="page-services" className="bg-[#faf9f6]">
      <Seo title="Services" description="PCOS, PMOS, perimenopause, thyroid, PMS and fertility awareness. The conditions women are told to just live with - and the holistic root-cause path." path="/services" />
      <section className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="max-w-3xl">
          <Overline>Services</Overline>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.04] font-normal text-[#333] mt-5">
            What I work with,
            <br />
            <span className="italic">and how we work.</span>
          </h1>
          <p className="mt-8 text-lg text-[#3d3d3d] font-normal leading-relaxed">
            Every woman who arrives at Aima Health comes with her own story  - 
            but there are patterns I see again and again. Below are the
            conditions and themes I specialise in. If yours isn't named here,
            please reach out; you may still be in the right place.
          </p>
        </div>

        <div className="mt-20 space-y-6">
          {SERVICES.map((s, i) => (
            <article
              key={s.slug}
              data-testid={`services-row-${s.slug}`}
              className="grid md:grid-cols-12 gap-8 md:gap-12 items-start border-t border-[#e5e0d8] pt-10"
            >
              <div className="md:col-span-1 font-serif text-3xl text-[#5fa292]">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="md:col-span-5">
                <h2 className="font-serif text-3xl md:text-4xl text-[#333] tracking-tight font-normal">
                  {s.title}
                </h2>
                <ul className="mt-5 space-y-2">
                  {s.points.map((p) => (
                    <li
                      key={p}
                      className="text-sm text-[#3d3d3d] flex items-center gap-2 font-normal"
                    >
                      <span className="w-1 h-1 rounded-full bg-[#5fa292]" />{" "}
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="md:col-span-6">
                <p className="text-lg text-[#3d3d3d] font-normal leading-relaxed">
                  {s.summary}
                </p>
                <p className="mt-4 text-base text-[#3d3d3d] font-normal leading-relaxed">
                  We may use targeted functional testing (DUTCH, full thyroid
                  panel, gut health and targeted blood tests) to bring real clarity, and
                  build a personalised protocol from there.
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-24 rounded-3xl bg-[#cbdad6]/40 border border-[#e5e0d8] p-10 md:p-14 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <Overline>The process</Overline>
            <h3 className="font-serif text-3xl md:text-4xl mt-4 text-[#333] font-normal tracking-tight">
              An informed, considered path.
            </h3>
            <p className="mt-5 text-[#3d3d3d] font-normal leading-relaxed">
              Discovery call → comprehensive intake → optional functional
              testing → personalised protocol → support across the months that
              real change requires.
            </p>
          </div>
          <div className="flex md:justify-end">
            <Link to="/work-with-me" data-testid="services-cta">
              <Button className="bg-[#5fa292] hover:bg-[#4d8275] text-white rounded-full px-8 h-12">
                See programmes & pricing
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
